// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__14pZX","label":"SetPasswdForm_label__3KprN"};